import { daekyoSpaceAPI } from '@/api';
import CommonUserListContainer from '@/components/common/CommonUserListContainer';
import DaekyoHeader from './DaekyoHeader';
import { createColumnHelper, ColumnDef } from '@tanstack/react-table';

interface DaekyoUserDataType {
  uid: string;
  phone: string;
  tuni_count: number;
  tuni_count_total: number;
  createdAt: string;
}

const columnHelper = createColumnHelper<DaekyoUserDataType>();

const getColumns = (): ColumnDef<DaekyoUserDataType, any>[] => {
  const baseColumns = [
    columnHelper.accessor('uid', {
      header: 'UID',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('phone', {
      header: '전화번호',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('tuni_count', {
      header: '오늘의 캐릭터 생성 횟수',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('tuni_count_total', {
      header: '캐릭터 생성 누적 횟수',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('createdAt', {
      header: '가입 날짜',
      cell: (info) => new Date(info.getValue()).toLocaleDateString(),
    }),
  ];

  return baseColumns.filter(Boolean) as ColumnDef<DaekyoUserDataType, any>[];
};

const DaekyoUserContainer = () => {
  return (
    <CommonUserListContainer<DaekyoUserDataType>
      HeaderComponent={DaekyoHeader}
      queryKey="getUsersDaekyo"
      queryFn={() =>
        daekyoSpaceAPI.getUsers({
          code: import.meta.env.VITE_SECRET_API_KEY,
        })
      }
      columns={getColumns}
    />
  );
};

export default DaekyoUserContainer;
